import createEthereumJsTx from './create-ethereumjs-tx.js'

function prepareRawTx(signedTx) {
  // serialize and get txId
  const rawTx = signedTx.serialize()
  const txId = signedTx.hash().toString('hex')
  return { rawTx, txId }
}

export async function signUnsignedTxWithSigner(unsignedTx, signer) {
  const tx = createEthereumJsTx(unsignedTx)

  const ethSigner = async (data) => {
    const { signature, recovery } = await signer.sign({
      data,
      enc: 'sig,rec',
      signatureType: 'ecdsa',
    })
    return { signature, recid: recovery }
  }

  const signedTx = await tx.signWithSigner(ethSigner)

  return prepareRawTx(signedTx)
}

export default function signUnsignedTx(unsignedTx, privateKey) {
  const tx = createEthereumJsTx(unsignedTx)

  const signedTx = tx.sign(privateKey)

  return prepareRawTx(signedTx)
}
